import { Link } from 'react-router-dom';
import Explore from '../pages/Explore';



const TopProblems = () => {

     return (
          <section className="problems-section-white">
               <div className="container">

                    <div className="section-header">
                         <div className="title-area">
                              <span className="kicker">Community Insight</span>
                              <h1>Ideas & Problems Feed</h1>
                              <p>
                                   Explore powerful ideas and real-world problems. Discover what people are building and what needs to be solved next.
                              </p>

                              <div className="type-tags">
                                   <span className="tag problem">Problem</span>
                                   <span className="tag idea">Idea</span>
                              </div>
                         </div>
                         <Link to="/explore" className="btn-all">View All</Link>
                    </div>
               </div>


               <div className='forge-container'>
                    <Explore previewItems={true} />
               </div>
          </section>
     );
};

export default TopProblems;